<template>
  <div class="wrapper">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <div class="main-communication">
            <div class="communication-header">
              <h3 class="title">
                <div class="item">
                  홈
                </div>
              </h3>
            </div>
            <div class="communication-total">
              <div class="header">
                <ul class="list">
                  <li class="total">
                    <div class="contain">
                      <div class="title">
                        전체 APL
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.setupCount + clubAplData.aplStatsClub.idleCount}}
                      </div>
                    </div>
                  </li>
                  <li class="management">
                    <div class="contain">
                      <div class="title">
                        서비스 운영
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.setupCount}}
                      </div>
                    </div>
                  </li>
                  <li class="waiting">
                    <div class="contain">
                      <div class="title">
                        서비스 대기
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.idleCount}}
                      </div>
                    </div>
                  </li>
                  <li class="apl">
                    <div class="contain">
                      <div class="title">
                        APL 통신 오류
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.errorCount}}
                      </div>
                    </div>
                  </li>
                  <li class="pin">
                    <div class="contain">
                      <div class="title">
                        APL Down
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.inactiveCount}}
                      </div>
                    </div>
                  </li>
                  <li class="battery">
                    <div class="contain">
                      <div class="title">
                        배터리 부족
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.lowBattery}}
                      </div>
                    </div>
                  </li>
                  <li class="batteryOut">
                    <div class="contain">
                      <div class="title">
                        방전
                      </div>
                      <div class="content">
                        {{clubAplData.aplStatsClub.outBattery}}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="main-green">
            <div class="green-map">
              <!-- 낙구 확설(Class) : falling -->
              <div class="box">
                <div class="content" >
                  <div class="pin">
                    <vue-daum-map
                      :appKey="daumMap.appKey"
                      :center="daumMap.center"
                      :level.sync="daumMap.level"
                      :mapTypeId="daumMap.mapTypeId"
                      :libraries="daumMap.libraries"
                      @load="onLoad"
                      style="width:100%; height:100%;"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="green-status">
              <div class="header">
                <h4 class="title">
                  현재 그린 온도
                </h4>
                <div class="caption">
                  최근 업데이트
                </div>
                <div class="content">
                  <div class="contain">
                    <div class="date">
                      {{clubAplData.aplStatsHole.tempInfo.lastUpdateAt | formatDateTime}}
                    </div>
                    <div class="refresh" @click="setData">
                      <div class="item">
                        새로고침
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body">
                <ul class="list">
                  <!-- 영하(0℃ 미만)(Class) : subzero -->
                  <li class="average" :class="clubAplData.aplStatsHole.tempInfo.averageTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      평균 온도
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.averageTemp.temp) + '%' }">
                          온도상태
                        </div>
                      </div>
                    </div>
                    <!-- 온도 증감 : increase / 온도 감소 : decrease -->
                    <!--<div class="caption increase">
                      1℃
                    </div>-->
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.averageTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                  <!-- 영하(0℃ 미만) : subzero -->
                  <li class="maximum" :class="clubAplData.aplStatsHole.tempInfo.higherTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      최고 온도
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.higherTemp.temp) + '%' }">
                          온도상태
                        </div>
                      </div>
                    </div>
                    <div class="caption">
                      {{getCourseData(clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx).name}} Hole {{clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx == null ? '' : viewHoleNo(clubAplData.aplStatsHole.tempInfo.higherTemp.hlidx)}}
                    </div>
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.higherTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                  <!-- 영하(0℃ 미만) : subzero -->
                  <li class="minimum" :class="clubAplData.aplStatsHole.tempInfo.lowerTemp.temp < 0 ? 'subzero' : ''">
                    <div class="title">
                      최저 온도
                    </div>
                    <div class="progress">
                      <div class="bar">
                        <!-- 영상일 때(폭염 기준 35℃)(Style) : (100% / 35) / 온도 -->
                        <!-- 영하일 때(한파 기준 -15℃)(Style) : (100% / 15) / (온도 : 양수 변환)-->
                        <div class="item" :style="{ height: getTempGraphHeight(clubAplData.aplStatsHole.tempInfo.lowerTemp.temp) + '%' }">
                          온도상태
                        </div>
                      </div>
                    </div>
                    <div class="caption">
                      {{getCourseData(clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx).name}} Hole {{clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx == null ? '' : viewHoleNo(clubAplData.aplStatsHole.tempInfo.lowerTemp.hlidx)}}
                    </div>
                    <div class="content">
                      <div class="temperature">
                        {{clubAplData.aplStatsHole.tempInfo.lowerTemp.temp}}
                      </div>
                      <div class="unit">
                        ℃
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="green-board scroll-body">
              <!-- 데이터 없을때(Class) : none -->
              <div class="body dev_headerLine" :class="clubAplData.aplStatsHole.holeList.length === 0 ? 'none' : ''">
                <div class="table thead">
                  <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                  <div class="fixed grid">
                    <div class="contain">
                      <table>
                        <colgroup>
                          <col class="course">
                          <col class="hole">
                          <col class="temperature">
                          <col class="communication">
                          <col class="battery">
                        </colgroup>
                        <thead>
                        <tr>
                          <th class="course">
                            <div class="item">
                              코스
                            </div>
                          </th>
                          <th class="hole">
                            <div class="item">
                              홀
                            </div>
                          </th>
                          <th class="aplId">
                            <div class="item">
                              APL ID
                            </div>
                          </th>
                          <th class="temperature">
                            <div class="item">
                              온도
                            </div>
                          </th>
                          <th class="communication">
                            <div class="item">
                              보고
                            </div>
                          </th>
                          <th class="battery">
                            <div class="item">
                              배터리
                            </div>
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="table tbody">
                  <div class="contain">
                    <table>
                      <colgroup>
                        <col class="course">
                        <col class="hole">
                        <col class="aplId">
                        <col class="temperature">
                        <col class="communication">
                        <col class="battery">
                      </colgroup>
                      <tbody>
                      <tr v-for="holeInfo in clubAplData.aplStatsHole.holeList" :key="holeInfo.hlidx">
                        <td class="course" :rowspan="getCourseData(holeInfo.hlidx).endIdx - getCourseData(holeInfo.hlidx).startIdx" v-if="getCourseData(holeInfo.hlidx).startIdx == holeInfo.hlidx">
                          {{getCourseData(holeInfo.hlidx).name}}
                        </td>
                        <td class="hole">
                          Hole {{viewHoleNo(holeInfo.hlidx)}}
                        </td>
                        <td class="aplId">
                          {{holeInfo.aplId}}
                        </td>
                        <td class="temperature">
                          {{holeInfo.temp == null ? '-' : holeInfo.temp}}{{holeInfo.temp == null ? '' : '℃'}}
                        </td>
                        <td :class="holeInfo.isActive == false ? 'communicationAbnormal' : 'communication'">
                          {{holeInfo.isActive == false ? 'Error' : '정상'}}
                        </td>
                        <td v-if="holeInfo.isActive == true" :class="holeInfo.lowBattery == true ? 'batteryAbnormal' : 'battery'">
                          {{holeInfo.lowBattery == true ? '충전 필요' : '정상'}}({{holeInfo.battery == null ? '-' : holeInfo.battery}}{{holeInfo.battery == null ? '' : '%'}})
                        </td>
                        <td v-if="holeInfo.isActive == false" class="battery">
                          -
                        </td>
                      </tr>
                      </tbody>
                      <tbody class="none">
                      <tr>
                        <td colspan="8">
                          데이터가 없습니다.
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <mainBoardPopup></mainBoardPopup>
      <footerLayout></footerLayout>
      <introLayout></introLayout>
    </div>
  </div>
</template>

<script>
/* Layout */
import FooterLayout from '../layout/Footer.vue'
import HeaderLayout from '../layout/Header.vue'
import IntroLayout from '../layout/Intro.vue'
import LeftLayout from '../layout/Left.vue'

/* Popup */
import MainBoardPopup from '../popup/MainBoard.vue'
/* global kakao */
import VueDaumMap from 'vue-daum-map'

import { homeService, userService } from '../../router'

export default {
  name: 'HO101',
  data () {
    return {
      daumMap: {
        marker: null,
        markerLabel: null,
        center: {
          lat: null,
          lng: null
        },
        bounds: {
          leftTop: {
            lat: null,
            lng: null
          },
          rightBottom: {
            lat: null,
            lng: null
          }
        },
        appKey: process.env.KAKAO_MAP_KEY,
        level: 4, // 지도의 레벨(확대, 축소 정도),
        mapTypeId: VueDaumMap.MapTypeId.HYBRID, // 맵 타입
        libraries: [], // 추가로 불러올 라이브러리
        map: null // 지도 객체. 지도가 로드되면 할당됨.
      },
      selectedHlidx: null,
      holeListByCourseId: [],
      clubAplData: {
        clubInfo: {
          name: ''
        },
        aplStatsClub: {
          setupCount: 0,
          idleCount: 0,
          inactiveCount: 0,
          lowBattery: 0
        },
        aplStatsHole: {
          tempInfo: {
            averageTemp: {
              temp: null
            },
            higherTemp: {
              temp: null,
              hlidx: null
            },
            lowerTemp: {
              temp: null,
              hlidx: null
            }
          },
          issueList: [],
          holeList: [],
          lastUpdateAt: null
        },
        clubInfoCourse: []
      }

    }
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    IntroLayout,
    MainBoardPopup,
    VueDaumMap
  },
  mounted: async function () {
    const { data } = await userService.getAll()
    this.userInfo = data

    if (this.userInfo.userRole === 'ClubManager') {
      this.currentClubCode = this.userInfo.ccode
      this.setData()
    } else {
      if (this.$route.query.ccode === '') {
        this.currentClubCode = this.clubInfoList[0].ccode
      } else {
        this.currentClubCode = this.$route.query.ccode
      }
      this.setClubInfo()
      this.setData()
    }
  },
  methods: {
    onLoad (map) {
      this.daumMap.map = map
      let mapTypeControl = new kakao.maps.MapTypeControl()
      this.daumMap.map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT)
    },
    getCourseData: function (hlidx) {
      let courseData = {}
      if (hlidx != null) {
        for (let i = 0; i < this.clubAplData.clubInfoCourse.length; i++) {
          if ((this.clubAplData.clubInfoCourse[i].startIdx <= hlidx) && (this.clubAplData.clubInfoCourse[i].endIdx > hlidx)) {
            courseData = this.clubAplData.clubInfoCourse[i]
          }
        }
      }
      return courseData
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    setData: function () {
      homeService.getClubAplData(this.currentClubCode).then(response => {
        this.clubAplData = response.data
        this.clubAplData.aplStatsHole.holeList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
        setTimeout(
          e => {
            this.daumMap.center.lat = this.clubAplData.clubInfo.lat
            this.daumMap.center.lng = this.clubAplData.clubInfo.lon

            let leftTop = {
              lat: this.clubAplData.clubInfo.lat + this.clubAplData.clubInfo.halfLat,
              lng: this.clubAplData.clubInfo.lon - this.clubAplData.clubInfo.halfLon
            }
            let rightBottom = {
              lat: this.clubAplData.clubInfo.lat - this.clubAplData.clubInfo.halfLat,
              lng: this.clubAplData.clubInfo.lon + this.clubAplData.clubInfo.halfLon
            }

            let bounds = new kakao.maps.LatLngBounds()
            bounds.extend(new kakao.maps.LatLng(leftTop.lat, leftTop.lng))
            bounds.extend(new kakao.maps.LatLng(rightBottom.lat, rightBottom.lng))
            this.daumMap.map.setBounds(bounds)

            let markerImage = new kakao.maps.MarkerImage(
              'static/assets/images/content/pc/pin-type01.png',
              new kakao.maps.Size(20, 33)
            )
            for (let i in this.clubAplData.aplStatsHole.holeList) {
              let lat = this.clubAplData.aplStatsHole.holeList[i].lat
              let lng = this.clubAplData.aplStatsHole.holeList[i].lon
              let aplId = this.clubAplData.aplStatsHole.holeList[i].aplId
              let isActive = this.clubAplData.aplStatsHole.holeList[i].isActive
              let lowBattery = this.clubAplData.aplStatsHole.holeList[i].lowBattery

              let marker = new kakao.maps.Marker({
                position: new kakao.maps.LatLng(lat, lng),
                image: markerImage,
                map: this.daumMap.map,
                clickable: true,
                data: this.clubAplData.aplStatsHole.holeList[i]
              })

              kakao.maps.event.addListener(marker, 'click', function () {
                console.log(aplId)
              })

              let color = '#000000'

              if (!isActive) {
                color = '#d0202e'
              } else if (lowBattery) {
                color = '#2063d2'
              }

              this.daumMap.markerLabel = new kakao.maps.CustomOverlay({
                position: new kakao.maps.LatLng(lat, lng),
                content: `<div style="background-color:#FFFFFF; color:${color}; text-align:center; padding:3px 5px 3px 5px; margin-top:-60px; border-radius:40%;">` + aplId + `</div>`
              })
              this.daumMap.markerLabel.setMap(this.daumMap.map)
            }
          },
          200
        )
      }).catch(error => {
        console.log('getClubAplData.err.===>', error)
      })
    },
    getTempGraphHeight: function (temp) {
      let tempHeight = 0
      if (temp < 0) {
        tempHeight = (100 * Math.abs(temp)) / 15
      } else {
        tempHeight = (100 * Math.abs(temp)) / 35
      }
      return tempHeight
    },
    moveHoleDetail: function (hlidx) {
      this.moveMenu(`/GR001?ccode=${this.currentClubCode}&courseId=${this.getCourseData(hlidx).courseId}&hlidx=${hlidx}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/HO101.vue